module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "reviewRank5"
  }, [_c('div', {
    staticClass: "reviewRank5__title"
  }, [_c('span', {
    staticClass: "reviewRank5__titleLeft"
  }, [_vm._t("titleLeft")], 2), _vm._v(" "), _c('span', {
    staticClass: "reviewRank5__titleRight"
  }, [_vm._t("titleRight")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "reviewRank5__flex"
  }, [_vm._l((5), function(i) {
    return [_c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.output),
        expression: "output"
      }],
      attrs: {
        "type": "radio",
        "id": _vm.id + '_' + i,
        "name": _vm.id
      },
      domProps: {
        "value": i,
        "checked": _vm._q(_vm.output, i)
      },
      on: {
        "change": function($event) {
          _vm.output = i
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": _vm.id + '_' + i
      }
    })])]
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0439f9cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/review/Tags.vue
// module id = 435
// module chunks = 1